<mat-slide-toggle [formControl]="formControl" [formlyAttributes]="field" [checked]="to['checked']"
    [disabled]="to.disabled" (change)="valueChangeFn(field.key, field.id, $event)">
    {{to.label}}
</mat-slide-toggle>
<!-- <mat-slide-toggle [formControl]="$any(form.get('formControl'))" [formlyAttributes]="field"  (change)="valueChangeFn(field.key, field.id, $event)">
    {{to.label}}
</mat-slide-toggle> -->